/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import { __decorate } from "tslib";
import range from 'lodash.range';
import { action, computed, observable } from 'mobx';
/**
 * This store contains the annotations that are displayed
 * in the labeler. Read more about how this store works to
 * support annotation resizing in `labelingStores.md`.
 */
export class LabelerAnnotationsStore {
    constructor() {
        this.annotations = [];
    }
    get annotationsPerTokenMap() {
        const initialEntries = Array.from({ length: this._tokenCount }, (_, index) => [index, []]);
        const map = new Map(initialEntries);
        this.annotations.forEach(a => range(a.startToken, a.endToken + 1).forEach(index => map.get(index).push(a)));
        return map;
    }
    initialize(tokenCount) {
        this._tokenCount = tokenCount;
    }
    setAnnotations(annotations) {
        this.annotations = Array.from(annotations);
    }
    startAnnotationResize(annotationId, startIndex, endIndex) {
        const annotationToUpdate = this.annotations.find(a => a.id === annotationId);
        this.annotations.forEach(a => {
            a.opacity = 0.5;
        });
        annotationToUpdate.opacity = 1;
        annotationToUpdate.endToken = endIndex;
        annotationToUpdate.startToken = startIndex;
    }
    stopAnnotationResize() {
        this.annotations.forEach(a => {
            a.opacity = 1;
        });
    }
}
__decorate([
    observable.deep
], LabelerAnnotationsStore.prototype, "annotations", void 0);
__decorate([
    computed
], LabelerAnnotationsStore.prototype, "annotationsPerTokenMap", null);
__decorate([
    action
], LabelerAnnotationsStore.prototype, "initialize", null);
__decorate([
    action
], LabelerAnnotationsStore.prototype, "setAnnotations", null);
__decorate([
    action
], LabelerAnnotationsStore.prototype, "startAnnotationResize", null);
__decorate([
    action
], LabelerAnnotationsStore.prototype, "stopAnnotationResize", null);
